import { Link } from '@utilitywarehouse/hearth-react';
import {
  LandlineMediumIcon,
  LaunchMediumIcon,
} from '@utilitywarehouse/hearth-react-icons';

import { EXTERNAL_LINKS } from '@constants/externalLinks';

import { PlanTypes } from '../types';

const planTooltipContent = {
  [PlanTypes.FTTP]: (
    <>
      Full Fibre connects your broadband using lightning-fast fibre optic cables
      directly to your home. It’s the UK’s most reliable broadband technology,
      giving you faster speeds with fewer dropouts.
      <br />
      <br />
      <Link
        href={EXTERNAL_LINKS.fibreTariffUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        More about fibre broadband
      </Link>
    </>
  ),
  [PlanTypes.FTTC]: (
    <>
      Part Fibre broadband uses a combination of fibre cables and older copper
      cables to connect to your home.
      <br />
      <br />
      <Link
        href={EXTERNAL_LINKS.fibreTariffUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        More about fibre broadband
      </Link>
    </>
  ),
  [PlanTypes.Copper]:
    'Copper broadband uses older copper cables to connect to your home.',
};

const sectionTitles = {
  [PlanTypes.FTTP]: 'Full Fibre plans',
  [PlanTypes.FTTC]: 'Part Fibre plans',
  [PlanTypes.Copper]: 'Copper plan',
} as const;

const pageTitles = {
  [PlanTypes.FTTP]: 'Choose a Full Fibre plan',
  [PlanTypes.FTTC]: 'Choose a Part Fibre plan',
  [PlanTypes.Copper]: 'Choose a Copper plan',
} as const;

const getPlanDescription = (
  showDigitalHomePhone: boolean,
  planType: PlanTypes
) => {
  if (planType === PlanTypes.FTTP) {
    return (
      <>
        <LaunchMediumIcon />
        <span>
          <b>Most reliable</b> connection
        </span>
      </>
    );
  }

  // FTTC plans without a landline (e.g. Fibre 40, Fibre 80 which now has VoIP as an optional add-on) don't get a badge
  if (planType === PlanTypes.FTTC && showDigitalHomePhone) {
    return null;
  }

  return (
    <>
      <LandlineMediumIcon />
      <span>
        <b>Landline</b> included
      </span>
    </>
  );
};

const getPageTitle = (hasTabs: boolean, technology: PlanTypes) =>
  hasTabs ? 'Choose your plan' : pageTitles[technology];

export { sectionTitles, getPageTitle, planTooltipContent, getPlanDescription };
